import { render, staticRenderFns } from "./ScenesSelection.vue?vue&type=template&id=6d87dbfc&scoped=true"
import script from "./ScenesSelection.vue?vue&type=script&lang=ts"
export * from "./ScenesSelection.vue?vue&type=script&lang=ts"
import style0 from "./ScenesSelection.vue?vue&type=style&index=0&id=6d87dbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d87dbfc",
  null
  
)

export default component.exports